import { useGetLoggedInUser } from "@/hooks/use-get-logged-in-user";
import { usePathname } from "next/navigation";
import { useCallback } from "react";
import { toast } from "sonner";
import { useAccount } from "wagmi";
import { useSidebar } from "../stores/sidebar.atoms";

export function useConnectUser() {
    const [, setSidebar] = useSidebar();
    const { user: userProfile } = useGetLoggedInUser();
    const { address, isConnecting, isReconnecting } = useAccount();

    const pathname = usePathname();

    const isWalletLoading = isConnecting || isReconnecting || userProfile === undefined;
    const isWalletConnected = isWalletLoading ? undefined : address != null && userProfile?.id === address;

    const isLoggedIn = userProfile === undefined ? undefined : userProfile !== null;

    const connectWithWallet = useCallback(
        (type?: "login" | "signup") => {
            if (isWalletConnected === true) {
                return "already-connected" as const;
            }
            if (isWalletConnected === false) {
                setSidebar({ open: true, relativeRedirectUrl: pathname ?? undefined, type: type ?? "login" });
            } else {
                toast.error("Error", {
                    description: "Wallet is not yet connected, wait a few seconds",
                });
            }
        },
        [isWalletConnected, pathname, setSidebar],
    );

    const connect = useCallback(
        (type?: "login" | "signup") => {
            if (isLoggedIn === true) {
                return "already-connected" as const;
            }
            if (isLoggedIn === false) {
                setSidebar({ open: true, relativeRedirectUrl: pathname ?? undefined, type: type ?? "login" });
            } else {
                toast.error("Error", {
                    description: "User is not yet connected, wait a few seconds",
                });
            }
        },
        [isLoggedIn, pathname, setSidebar],
    );

    return {
        isWalletConnected,
        isLoggedIn,
        connect,
        connectWithWallet,
    };
}
